import { $, $$ } from 'utils/dom';

const map = $('.map--two-columns');

if (map) {
  const hoverItem = $$('.map__center', map);

  const randomItem = () => {
    const randomItem = Math.floor(Math.random() * hoverItem.length);
    hoverItem[randomItem].classList.add('map__center--active');
  };

  randomItem();

  const removeActive = () => {
    hoverItem.forEach(item => {
      item.classList.remove('map__center--active');
    });
  };

  const addActive = item => {
    item.classList.add('map__center--active');
  };

  hoverItem.forEach(item => {
    item.addEventListener('mouseover', () => {
      removeActive();
      addActive(item);
    });
    item.addEventListener('touchstart', () => {
      removeActive();
      addActive(item);
    });
  });
}
